import { FC, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Box, Button, Dialog, Grid, IconButton, Typography } from "@material-ui/core";
import useStyles from "../Styles/ProjectModalStyles";
import { MdClose } from "react-icons/md";
import Lottie from "lottie-react";

import TrophyAnimation from '../../assets/animations/Trophy.json';

const SuccessModal: FC<any> = ({ open, setOpen, tokenName }: any) => {

    const classes = useStyles();

    const handleClose = (event: React.SyntheticEvent<any, Event>, reason: string) => {
        if (reason === 'backdropClick') return;
        setOpen(false);
    }

    return (
        <>
            <Box component="section">
                <Dialog
                    open={open}
                    onClose={handleClose}
                    className={classes.modalpages}
                    aria-labelledby="contribution"
                    aria-describedby="contribution-result"
                    disableEscapeKeyDown={false}
                >
                    <Grid
                        container
                        style={{
                            padding: "20px",
                            display: "block"
                        }}
                        direction="column"
                    >
                        <Grid
                            item
                        >
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="flex-end"
                            >
                                <Grid
                                    item
                                >
                                    <IconButton
                                        edge="end"
                                        color="inherit"
                                        aria-label="close"
                                        onClick={(event) => handleClose(event, 'buttonClick')}
                                    >
                                        <MdClose />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid 
                            item
                            lg={12}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Lottie animationData={TrophyAnimation} style={{
                                width: "180px",
                                height: "auto",
                            }} />
                        </Grid>
                        <Grid
                            item
                        >
                            <Grid 
                                container
                                justifyContent="center"
                                lg={12}
                            >
                                <Grid item lg={12}>
                                    <Typography variant="h3" className={classes.progressTitle}>
                                        Congratulations!
                                    </Typography>
                                </Grid>
                                <Grid item lg={9}>
                                    <Typography variant="body1" className={classes.progressMessage}>
                                        You have successfully staked your {tokenName} tokens!
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                        >
                            <Grid 
                                container
                                justifyContent="center"
                                lg={12}
                                direction="row"
                                style={{
                                    marginTop: "20px",
                                }}
                                spacing={2}
                            >
                                <Grid item lg={10} xs={10} md={10} sm={10}>
                                  <Button variant="outlined" color="secondary" fullWidth onClick={(e) => handleClose(e, 'buttonClick')}>
                                          Close
                                  </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Dialog>
            </Box>
        </>
    )
}

export default SuccessModal;